export default __webpack_public_path__ + "static/media/accessibilite.cf62194c.svg";